import React, { createContext, useEffect, useReducer } from 'react'
import { ACLReducer, initialState } from './reducer'
import { getModules } from './service'
import { ACLReducerActions, ContextACL } from './types'

type ACLProviderProps = {
  children: React.ReactNode
}

export const ACLContext = createContext<ContextACL>({
  state: initialState,
  dispatch: () => null,
})

export default function ACLProvider({ children }: ACLProviderProps) {
  const [state, dispatch] = useReducer(
    ACLReducer,
    initialState,
  )

  useEffect(() => {
    dispatch({ type: ACLReducerActions.setACL, payload: getModules() })
  }, [])

  return (
    <ACLContext.Provider value={{ state, dispatch }}>
      {children}
    </ACLContext.Provider>
  )
}
